import React from 'react';
import { downloadExcel } from '@/lib/biExcel';
export function BiExcelButton({ name, table, disabled, children }) {
  const [error, setError] = React.useState('');
  return <><button type="button" disabled={disabled} className="rounded-lg border border-red-800 bg-white px-4 py-2 text-sm font-semibold text-red-800 disabled:opacity-50" onClick={() => {
    setError('');
    try { downloadExcel(name, table()); } catch (e) { setError(e.message || 'No se pudo generar el Excel. Reduce el periodo e inténtalo de nuevo.'); }
  }}>{children}</button>{error && <p role="alert" className="text-sm text-red-800">{error}</p>}</>;
}
